import rmskincareAPI from '../utils/rmskincareAPI'
import { CategoryGroupId } from '../enum/groupId'
// {
//   "data": {
//     "currentPage": 0,
//     "totalPage": 1,
//     "totalElements": 1,
//     "content": [
//       {
//         "id": 1,
//         "paymentMethod": {
//           "id": 1,
//           "name": "Jessica-QuickPay",
//           "info": "N/A",
//           "tax": 0.045,
//           "status": 1
//         },
//         "reason": {
//           "id": 15,
//           "name": "facility",
//           "children": [],
//           "parent": null
//         },
//         "amount": 2000,
//         "locked": false,
//         "modifyByEmployee": null,
//         "status": 1,
//         "comment": "test",
//         "recordDateTime": "2020/12/26 01:53:48",
//       }
//     ]
//   }
// }

const expenseApi = {
  // Get Expense
  searchExpense: async (query) => {
    const result = await rmskincareAPI.get(`management/finance/cashout${query}`)
    return result.data.data
  },

  expenseExport: async (startDate, endDate) => {
    let result = await rmskincareAPI
      .get(
        `management/finance/cashout/export?endDate=${endDate}&startDate=${startDate}`,
        { responseType: 'blob' }
      )
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'CashOutReport.xlsx') //or any other extension
        document.body.appendChild(link)
        link.click()
      })
  },  

  getExpenseSum: async (query) => {
    const result = await rmskincareAPI.get(`management/finance/cashout/sum${query}`)
    return result.data.data
  },

  // Get Expense Category
  getExpenseCategories: async () => {
    const result = await rmskincareAPI.get(
      `management/category/${CategoryGroupId.CASH_OUT_REASON}`
    )
    return result.data.data
  },

  patchSalesProfitUnlock: async (id, status) => {
    const result = await rmskincareAPI.patch(
      `/management/finance/cashout/lock/${id}?lock=${status}`
    )
    return result.data
  },

  // Add/Create Bank Transaction History
  createExpense: async (requestBody, employeeId) => {
    let query = employeeId == null ? '' : `?employeeId=${employeeId}`

    const result = await rmskincareAPI.post(
      '/management/finance/cashout' + query,
      requestBody
    )
    return result.data.data
  },

  // Get Bank Transcation History By Transcation ID
  findExpenseById: async (expenseId) => {
    const result = await rmskincareAPI.get(
      `/management/finance/cashout/${expenseId}`
    )
    return result.data.data
  },

  editExpense: async (expenseId, requestBody, employeeId) => {
    let query = employeeId == null ? '' : `?employeeId=${employeeId}`

    const result = await rmskincareAPI.put(
      `management/finance/cashout/${expenseId}` + query,
      requestBody
    )
    return result.data.data
  },

  deleteExpense: async (expenseId) => {
    let result = await rmskincareAPI.delete(
      `management/finance/cashout/${expenseId}`
    )
    return result.data.data
  },
}

export default expenseApi
